import { Component, Input } from '@angular/core';

@Component({
    selector: 'cmps-flag',
    template: `
        <div [class]="flagClass">
            <!-- Straight line conditionally displayed -->
            <div
                *ngIf="!isOverlapping"
                class="flag-line-simple-bar"
            ></div>
            <!-- Curved path displayed when overlapping -->
            <ng-container *ngIf="isOverlapping">
                <svg
                    class="flag-path"
                    width="24"
                    height="8"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 30 10"
                >
                    <path
                        d="M5 2 L5 5 L30 5 L30 8"
                        stroke="#363636"
                        fill="none"
                        stroke-width="1"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                </svg>
            </ng-container>
        </div>
    `,
})
export class CmpsFlagComponent {
    @Input() isOverlapping: boolean;
    @Input() flagClass: string;
}
